"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterviewByCodeFilter = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const faCheckCircle_1 = require("@fortawesome/free-solid-svg-icons/faCheckCircle");
const InputText_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/InputText"));
const Button_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/Button"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const FormErrors_1 = __importDefault(require("chaire-lib-frontend/lib/components/pageParts/FormErrors"));
const geojson_validation_1 = require("geojson-validation");
/**
 * Textbox input for access code filter
 *
 * @param param0 description of the filtered column
 * @returns
 */
const InterviewByCodeFilter = ({ t, column: { filterValue, setFilter } }) => {
    const [currentValue, setCurrentValue] = react_1.default.useState(!(0, LodashExtensions_1._isBlank)(filterValue) && filterValue.value ? filterValue.value : filterValue);
    const [hasError, setHasError] = react_1.default.useState(false);
    const validateValue = (value) => {
        try {
            const geojsonObject = JSON.parse(value);
            const feature = (0, geojson_validation_1.isFeatureCollection)(geojsonObject) ? geojsonObject.features[0] : geojsonObject;
            if ((0, geojson_validation_1.isFeature)(feature) && (0, geojson_validation_1.isPolygon)(feature.geometry)) {
                setCurrentValue(feature);
                setHasError(false);
            }
            else {
                setHasError(true);
                setCurrentValue(undefined);
            }
        }
        catch (_a) {
            setHasError(true);
            setCurrentValue(undefined);
        }
    };
    // FIXME: Instead of an InputText, the filter should be a map with a polygon drawing tool
    return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        react_1.default.createElement("label", { htmlFor: 'homeGeographySearchInput' }, t('admin:interviewByHomeGeographyFilter:Title')),
        react_1.default.createElement(InputText_1.default, { id: "homeGeographySearchInput", value: JSON.stringify(currentValue), placeholder: t('admin:interviewByHomeGeographyFilter:Placeholder'), onValueChange: (newValue) => validateValue(newValue.target.value) }),
        react_1.default.createElement(Button_1.default, { onClick: () => setFilter(!(0, LodashExtensions_1._isBlank)(currentValue) ? { value: currentValue, op: 'eq' } : currentValue), icon: faCheckCircle_1.faCheckCircle, label: "", size: "small", title: t('admin:interviewByHomeGeographyFilter:Button') }),
        hasError && react_1.default.createElement(FormErrors_1.default, { errors: [t(['admin:interviewByHomeGeographyFilter:NotAPolygonFeature'])] })));
};
exports.InterviewByCodeFilter = InterviewByCodeFilter;
exports.default = (0, react_i18next_1.withTranslation)(['admin', 'main'])(exports.InterviewByCodeFilter);
//# sourceMappingURL=InterviewByHomeGeographyFilter.js.map